import React from "react";

const Birthyear = ({ setBirthYear, birthYear }) => {
  const yearsList = React.useMemo(() => {
    let years = [];
    for (let year = new Date().getFullYear() - 18; year >= 1930; year--) {
      years.push(year);
    }

    return years.map((year) => (
      <option value={year} key={year}>
        {year} 年
      </option>
    ));
  }, []);

  return (
    <React.Fragment>
      <h6 className="text-fw-bold text-center mb-3_5 line-height-2">
        生まれた年を教えてください（非公開）
      </h6>
      <p className="p-0 text-fz-small text-center">
        *後で変更できないので正確にご入力ください。
      </p>
      <div
        className="text-center"
        style={{ paddingTop: "30px", paddingBottom: "180px" }}
      >
        <select
          className="form-control border-bottom"
          style={{ width: "50%", display: "inline-block", border: "none" }}
          name="birthday_year"
          id="birthday_year"
          onChange={(e) => setBirthYear(Number(e.target.value))}
          value={birthYear}
        >
          <option value="">--</option>
          {yearsList}
        </select>
      </div>
    </React.Fragment>
  );
};

export default Birthyear;
